import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FaIcons from 'react-icons/fa';

const { FaTiktok } = FaIcons;

const Footer = () => {
  return (
    <footer className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-t border-gray-200 dark:border-gray-700 mt-16 w-full">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col items-center justify-center space-y-6 text-center">
          
          {/* Fila Superior: InnovaPrompt | Una aplicación de Appfred */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-gray-700 dark:text-gray-300">
            {/* Logo con colores exactos del Header */}
            <div className="flex items-center text-lg sm:text-xl font-bold italic tracking-tight">
              <span style={{ color: "#2B5596" }}>Innova</span>
              <span style={{ color: "#F54CC8" }}>Prompt</span>
            </div>
            
            {/* Pleca divisoria */}
            <span className="hidden sm:inline text-gray-300 dark:text-gray-600 font-light text-2xl">|</span>
            
            {/* Atribución a Appfred con estilo Premium */}
            <div className="flex items-center gap-2 text-sm sm:text-base">
              <span className="font-medium">Una aplicación de</span>
              <a
                href="https://appfred.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-black bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500 hover:opacity-80 transition-opacity tracking-tighter text-xl"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Appfred
              </a>
            </div>
          </div>

          {/* Fila Inferior: Copyright y Redes (Solo Icono) */}
          <div className="flex items-center justify-center gap-6 pt-2">
            <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-500 font-medium">
              © 2026, Alfredo Menéndez
            </span>
            
            {/* Divisor pequeño */}
            <div className="h-4 w-px bg-gray-200 dark:bg-gray-700"></div>
            
            {/* Solo el icono de TikTok */}
            <a
              href="https://www.tiktok.com/@alfredmenendez"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#F54CC8] transition-all transform hover:scale-125"
              aria-label="TikTok de Alfredo Menéndez"
            >
              <SafeIcon icon={FaTiktok} className="w-5 h-5" />
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;